import { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import CardItem from "../CardItem";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../Config";
import { Spin } from "antd";
import { dummyProducts } from "../dummyprduct";
import { Button as Buttons } from "react-bootstrap";

const Chicken = () => {
  const [products, setProducts] = useState<any[]>([]);
  const navigate = useNavigate();

  const getAllProduct = async () => {
    try {
      const response = await axios.get(
        `${API_URL}/api/product?category=chicken&page=1&limit=6&isDeleted=false`
      );
      if (response.data?.products?.length) {
        setProducts(response.data.products);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleNavChicken = () => {
    navigate("/chicken");
  };

  useEffect(() => {
    getAllProduct();
  }, []);

  return (
    <section className="py-4">
      <Container>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold">Buy Chicken meat Online</h2>
          <Buttons variant="light" className="fw-bold" onClick={()=>navigate("/chicken")}>
            See More →
          </Buttons>
        </div>
            <Row className="g-4">
              {products.length ? (
                products.map((product) => (
                  <Col key={product._id} md={3} sm={6} xs={6}>
                    <CardItem product={product} />
                  </Col>
                ))
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "70vh" }}
                >
                  <Spin size="large" className="custom-spin" />
                </div>
              )}
            </Row>
        {/* <div className="text-center pb-3 pt-4">
          <Button
            variant="contained"
            className="see-btn"
            onClick={handleNavChicken}
          >
            See More
          </Button>
        </div> */}
      </Container>
    </section>
  );
};

export default Chicken;
